var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images.length)?_c('div',{staticClass:"news-gallery px-3"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index},[_c('gallery-carousel',{attrs:{"gallery":[image]}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }